import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getTermFromState } from '../../../redux/selectors/i18n';
import { shouldShowZipModal } from '../../../redux/selectors/dma';
import { updateZipCodeAction } from '../../../redux/actions/zipCode';
import Modal from '../../../components/Modal'

const styles = {
  form: {
    width: 300,
    button: {
      height: '1.875rem',
      lineHeight: '1.875rem',
      padding: '0em 1em'
    },
    errorMsg: {
      width: '100%',
      maxWidth: 'none'
    }
  },
};
/**
 * Component to display the modal state for the user to enter a Zip Code
 * and submit it for the Payment estimation.
 */
class ZipCodeModal extends Component {
  static propTypes = {
    showZipCodeModal: PropTypes.bool.isRequired,
    updateZipCode: PropTypes.func.isRequired,
    zipCode: PropTypes.string,
    enterZipCodeLabel: PropTypes.string.isRequired,
    errorMsg: PropTypes.string,
    buttonText: PropTypes.string.isRequired,
  };
  static defaultProps = {
    zipCode: undefined,
    errorMsg: undefined,
  };
  constructor(props) {
    super(props);
    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.handleZipCodeChange = this.handleZipCodeChange.bind(this);
    this.state = {
      zipCodeValue: this.props.zipCode
    }
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.zipCode !== nextProps.zipCode) {
      this.setState({ zipCodeValue: nextProps.zipCode });
    }
  }
  // On the submission of the form fire this event
  onFormSubmit(event) {
    const { updateZipCode } = this.props;
    event.preventDefault();
    updateZipCode(this.state.zipCodeValue)
  }
  // Handler fo the changing Zip Code
  handleZipCodeChange(event) {
    this.setState({ zipCodeValue: event.target.value });
  }
  // If there are errors then display the error state
  renderErrorMsg() {
    const { errorMsg } = this.props;
    if (!errorMsg) {
      return undefined;
    }
    return (
      <label style={styles.form.errorMsg} htmlFor="zipCode" className="error error-container inventory-zip-code-error">{errorMsg}</label>
    )
  }
  render() {
    const { showZipCodeModal, enterZipCodeLabel, buttonText } = this.props;
    const { zipCodeValue } = this.state;
    const showModal = showZipCodeModal === true;

    return (
      <Modal contentLabel={enterZipCodeLabel} disableClose={true} isModalOpen={showModal} >
        <form onSubmit={this.onFormSubmit} className="nna-form" style={styles.form}>
          <div className="row">
            <div className="columns">
              <label htmlFor="zipCode">{enterZipCodeLabel}</label>
              <div className="input-group">
                <input name="zipCode" maxLength="5" value={zipCodeValue} className="input-group-field" type="text" onChange={this.handleZipCodeChange} />
                <div className="input-group-button">
                  <input type="submit" role="button" className="button" style={styles.form.button} value={buttonText} />
                </div>
              </div>
              {this.renderErrorMsg()}
            </div>
          </div>
        </form>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  showZipCodeModal: shouldShowZipModal(state),
  zipCode: state.dma.zipCode,
  enterZipCodeLabel: getTermFromState(state, 'zipCodeModal.zipEnter'),
  buttonText: getTermFromState(state, 'zipCodeModal.submitButton'),
  errorMsg: state.dma.zipCodeValidationError
});

const mapDispatchToProps = dispatch => ({
  updateZipCode: bindActionCreators(updateZipCodeAction, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ZipCodeModal);



/** WEBPACK FOOTER **
 ** ./src/pages/ModelView/ZipCodeModal/index.js
 **/